class EditVehicleController {

  constructor (ValidationRules, $scope, $rootScope) {
    'ngInject'
    this.validationRules = ValidationRules
    this.$rootScope = $rootScope
    $scope.$on('editVehicle:close', () => {
      this.editMode = false
    })
  }

  submitForm (form) {
    if (form.editVehicleForm.$valid) {
      this.onConfirm({name: this.friendlyName})
      .then(() => {
        this.editMode = false
      })
    }
  }

  activeEditMode () {
    this.$rootScope.$broadcast('deleteVehicle:close')
    this.friendlyName = this.vehicle.friendlyName
    this.editMode = !this.editMode
  }

  cancelForm () {
    this.editMode = !this.editMode
    this.friendlyName = this.vehicle.friendlyName
  }
}

export default EditVehicleController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/components/edit-vehicle/edit-vehicle.controller.js